import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import 'prop-types';
import * as React from 'react';
import { StyledTabList } from '../TabsList/StyledTabList.js';
import { jsx } from 'react/jsx-runtime';

var NavTabsList = /*#__PURE__*/React.forwardRef(function NavTabsList2(props, ref) {
  return /*#__PURE__*/jsx(StyledTabList, _objectSpread(_objectSpread({}, props), {}, {
    focusableOverflowNav: true,
    "aria-label": props["aria-label"] || "Secondary navigation",
    ref: ref,
    role: "navigation"
  }));
});
NavTabsList.displayName = "NavTabsList";

export { NavTabsList };
